<!-- <div class="layout"> -->
<youtube-player class="youtube-player site-m" videoId="{{ data.url }}" placeholderImageQuality="low" />
<!-- </div> -->
